import React,{useState, useEffect} from 'react';
import './jobs.css'
import Job from './Job';
import DataService from "../../firebase/firebaseOperation";
import UserHeader from '../../components/UserHeader';
import CompanyFooter from '../../components/CompanyFooter'
import Waves from '../../components/Waves';

function Jobs() {
  const [job,setjob] = useState();

  const fetchAllJobs = async ()=> {
    const val = await DataService.getAll("jobs");
    const reverse = val?.docs.reverse();
    setjob(reverse);
  }

  useEffect(()=>{
      fetchAllJobs();
  },[])


  return <div className='jobs'>
     <UserHeader/>
      <h1>In case you missed something, we have all The jobs posted by different Companies right Here !</h1>
      <div className='container-fluid content-box'>
          <div className='row jobsrow'>
                   {job?.map((jobid,index)=> <div key={index} className='col-xs-12 col-sm-6 col-lg-4 col-xl-3 col'><Job jobid={jobid}/></div>)}
          </div>
      </div>
      <Waves/>
      <CompanyFooter/>
  </div>;
}

export default Jobs;
